module.exports = __webpack_public_path__ + "a3a37ae8f4ea07212e18f7ef41e7ce32.MP3";